/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './batchDetailStart.tpl.html';
import './batchStart.tpl.html';

/**
 * Module for the batchStart view.
 */
angular
  .module('admin.batchstart', ['ngAnimate'])
  /**
   * Controller for the batchStart template.
   */
  .controller(
    'AdminBatchStartCtrl',
    function ($scope, $filter, $state, httpBatch, httpQueue, progressFactory, ALERT_EVENTS, VIEW_STATES) {
      var NOBATCH = 'NONE';

      $scope.batches = [];
      $scope.showBatchOne = true;
      $scope.enableBatchAnimation = false;

      /**
       * Function that will pad the loaded batches to 14.
       */
      function setBatches() {
        // pad the array with empty objects to fill the bar.
        var batchesInfo = { rows: [] };
        while (batchesInfo.rows.length < 12) {
          batchesInfo.rows.push({
            status: NOBATCH
          });
        }
        $scope.batches = batchesInfo.rows;
        $scope.currentBatch = $scope.batches[0];
      }

      /**
       * Create a class list for the passed batch based on it's properties.
       *
       * @param {boolean} last True if this is the last batch in the list.
       *
       * @returns {string} A space delimited string of classes that are valid for the boink.
       */
      $scope.getBoinkClass = function (last) {
        var cls = '';

        if (last) {
          cls = cls + ' sbsf-boink-last';
        }

        return cls;
      };

      /**
       * Submit a backup to be queued.
       */
      $scope.submitBackup = function () {
        return httpQueue.submitBackup().then(
          function () {
            progressFactory.backupInProgress = true;
          },
          function () {
            $scope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('SUBMIT_BACKUP_FAILED'));
            progressFactory.backupInProgress = false;
          }
        );
      };

      // Watches to toggle the tooltip state on the backup and export buttons when there are changes in backup state.
      $scope.$watch('backupInProgress ', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          $scope.backupBtnTooltip = $scope.backupInProgress
            ? $filter('i18n')('ACTION_PROGRESS_TTIP', $filter('i18n')('BACKUP'))
            : '';
          if (!$scope.backupInProgress) {
            $state.go(VIEW_STATES.ADMIN_HOME);
          }
        }
      });

      // load the batches history display.
      setBatches();
    }
  )
  /**
   *  Controller for a batch start detail view directive.
   */
  .controller('AdminBatchDetailStartCtrl', function ($scope, $filter, TYPES, dashboardUtils) {
    var batchDate, errorText, warningText, wasWereText;

    dashboardUtils.getDashboardPreferences().then(function (primaryObj) {
      $scope.dashboardPrefs = primaryObj;
    });
    $scope.TYPES = TYPES;

    /**
     * Returns the shortened version of the number if it is >=1000 for the type and object.
     *
     * @param {string} type - The object type.
     * @param {string} recordType - The record type.
     *
     * @return {string} The number or shortened version of the number
     */
    $scope.getTypeCount = function (type, recordType) {
      var objectType = $scope.batch && $scope.batch.typeCounts ? $scope.batch.typeCounts[type] : null,
        record = objectType ? objectType[recordType] : 0,
        num = record || 0;
      return $filter('shortNum')(num);
    };

    /**
     * Utility to determine is the object type is in a disabled state.
     *
     * @param {object} dashboardObj - The dashboard object.
     *
     * @return {boolean} - If object is disabled or not.
     */
    $scope.isObjectDisabled = function (dashboardObj) {
      return (
        $scope.getTypeCount(dashboardObj.objectName, 'updated') === 0 &&
        $scope.getTypeCount(dashboardObj.objectName, 'new') === 0 &&
        $scope.getTypeCount(dashboardObj.objectName, 'deleted') === 0
      );
    };

    batchDate = moment();
    $scope.batchDate = batchDate.format('ddd,  MMM D[,] YYYY');

    errorText = $filter('pluralize')(0, 'SINGLE_ERROR', 'NUM_ERRORS');
    warningText = $filter('pluralize')(0, 'SINGLE_WARNING', 'NUM_WARNINGS');
    wasWereText = $filter('i18n')('WERE');
    $scope.bigBoinkCls = 'sca-icon-cloud-boink';
    $scope.protectedPctCls = 'sbsf-title-blue';
    $scope.batchMsg = $filter('i18n')('NO_BACKUPS_YET');
    $scope.protectedPct = $filter('i18n')('GET_STARTED');
    $scope.batchWarn = $filter('i18n')('BATCH_MSG_TEMPLATE', [wasWereText, errorText, warningText]);
  })
  /**
   * The directive for the batch start detail view.
   */
  .directive('batchStartDetail', function () {
    return {
      templateUrl: 'admin/start/batch/batchDetailStart.tpl.html',
      scope: {
        batch: '=batch'
      },
      controller: 'AdminBatchDetailStartCtrl'
    };
  });
